// removed by extract-text-webpack-plugin
module.exports = {"LegendHeader":"_14YpV","LegendItem":"_1zU60","Legend":"_2tUFa","none":"_3YdyC","vertical":"_1BBNM","horizontal":"_1TLy7"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/Legend.css
// module id = 190
// module chunks = 3 4 5